<template>
  <div class="land-home-solutionBg">
    <el-row class="land-home-solution">
      <el-row class="home-solution-title">全场景解决方案，开启数字新成本之旅</el-row>
      <el-row
        :gutter="12"
        type="flex"
        justify="center"
        :class="{'isSolutionThree':isSolutionThree}"
      >
        <el-col
          v-for="(item, index) in solutionList"
          :key="index"
        >
          <el-card shadow="hover">
            <el-row class="home-solution-img"><img :src="item.solutionImg" /></el-row>
            <el-row class="home-solution-text">
              <el-row class="solution-title"><span style="color: #181f42;">{{item.title}}</span>
              </el-row>
              <el-row class="solution-text">{{item.description}}
              </el-row>
              <el-row class="solution-btn">
                <!-- <router-link
                  :to="{path:solutionRouter[index]}"
                  class="link-text"
                >
                  <el-button @click="clickSolution(item.clientGroup)">立即查看</el-button>
                </router-link> -->
                <a
                  :href="item.referringSite"
                  class="link-text"
                >
                  <el-button @click="clickSolution(item.clientGroup)">立即查看</el-button>
                </a>
              </el-row>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import { getSolutionList } from '@/api/landing'
export default {
  name: 'landHomeSolution',
  mounted () {
    this.getList()
  },
  data () {
    return {
      solutionList: [],
      isSolutionThree: false,
      solutionRouter: ['/developer', '/contractor']
    }
  },
  methods: {
    // 获取列表
    getList () {
      getSolutionList().then(res => {
        const { code, data, message } = res
        if (code === 200) {
          this.solutionList = data || []
          if (this.solutionList.length === 3) {
            this.isSolutionThree = true
          } else {
            this.isSolutionThree = false
          }
        } else {
          this.solutionList = []
          message && this.$message.error(message)
        }
      }).catch(() => {
        this.solutionList = []
      })
    },
    clickSolution (name) {
      switch (name) {
        case '建设方':
          this.sentLog(100102002)
          break
        case '施工方':
          this.sentLog(100102003)
          break
        case '咨询方':
          this.sentLog(100102004)
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.land-home-solutionBg {
  background: #f5f8fa
    url("../../../../../../assets/images/land-page/land-home/solutionBg.png")
    no-repeat left bottom;
}
.land-home-solution {
  width: 1200px;
  height: 746px;
  margin: auto;
  // background: #bfb1b7;
  ::v-deep .el-row {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
  ::v-deep .el-card {
    width: 582px;
    // width: 366px;
    height: 434px;
    background: #ffffff;
    box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.16);
    // box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.16);
    border-radius: 6px;
    border:0px;
    .el-card__body {
      padding: 0px;
    }
  }
  ::v-deep .el-card:hover {
    box-shadow: 0px 11px 13px 0px rgba(0, 0, 0, 0.16);
  }
  ::v-deep .el-rol {
    width: auto;
  }
  ::v-deep .el-col-24 {
    width: auto;
    padding-left: 17px !important;
    padding-right: 17px !important;
  }

  .home-solution-title {
    // height: 56px;
    font-size: 40px;
    font-weight: 600;
    color: #181f42;
    line-height: 56px;
    text-align: center;
    margin-top: 74px;
    margin-bottom: 65px;
  }

  .isSolutionThree {
    ::v-deep .el-card {
      width: 366px;
    }
  }
  .home-solution-img {
    // width: 582px;
    height: 232px;
    background: #d8d8d8;
    border-radius: 6px 6px 0px 0px;
    img {
      width: 582px;
      height: 232px;
    }
  }
  .home-solution-text {
    ::v-deep .el-row {
      text-align: center;
    }
    .solution-title {
      // height: 33px;
      font-size: 24px;
      font-weight: 600;
      // color: #181f42;
      line-height: 33px;
      margin-top: 20px;
      margin-bottom: 11px;
    }
    .solution-text {
      // height: 52px;
      font-size: 14px;
      font-weight: 400;
      color: #5c5c65;
      line-height: 26px;
      padding-left: 35px;
      padding-right: 30px;
      //控制显示文字的行数
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .solution-btn {
      margin-top: 20px;
      ::v-deep .el-button {
        width: 110px;
        height: 33px;
        line-height: 0;
        border-radius: 4px;
        border: 1px solid #4499ff;
        color: #4499ff;
        font-size: 14px;
        font-weight: 400;
      }
      ::v-deep .el-button:hover {
        background: #4499ff;
        color: #ffffff;
      }
    }
  }
}
</style>
